import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=a730bf34&scoped=true"
import script from "./base-button.vue?vue&type=script&setup=true&lang=js"
export * from "./base-button.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-button.vue?vue&type=style&index=0&id=a730bf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a730bf34",
  null
  
)

export default component.exports